import React from 'react'

class InviteEmail extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      sent: false
    }
  }

  inviteExternalSend = e => {
    e.preventDefault()

    this.props.sendExternalInvite(
      this.props.aid,
      this.props.emailAddress,
      this.props.firstName,
      this.props.lastName,
      "Hey, let's share recipes on Cook'n!"
    )

    this.setState((state, props) => ({
      sent: true
    }))
  }

  render() {
    const { sent } = this.state

    return (
      <span className="invite-email">
        <span className="invite-name">
          {this.props.firstName} {this.props.lastName}
        </span>
        <span className="invite-email-address">{this.props.emailAddress}</span>
        <a
          href="#"
          className="invite-tag"
          onClick={e => {
            this.inviteExternalSend(e)
          }}
          disabled={sent}
        >
          Add +
        </a>
      </span>
    )
  }
}

export default InviteEmail



// WEBPACK FOOTER //
// ./src/Components/InviteEmail.js